import { Availability } from '../../model/availability/availability';
import { LocalStorageService } from 'ngx-webstorage';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AvailabilityService } from '../../service/availability.service';
import { NotificationService } from '../../service/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ViewChild, TemplateRef } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';

declare let $: any;
const colors: any = {
  red: {
    primary: '#c31b3a',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  green: {
    primary: '#15e817',
    secondary: '#91ea92'
  }
};

@Component({
  selector: 'app-slot-calendar',
  templateUrl: './slot-calendar.component.html',
  styleUrls: ['./slot-calendar.component.css']
})
export class SlotCalendarComponent implements OnInit, OnChanges {
  slotList: Availability[];
  @Input('providerAvailability') providerAvailability: any;
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  visitType: string;
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();
  events: CalendarEvent[] = [];

  activeDayIsOpen: boolean = false;

  constructor(
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private _notificationService: NotificationService,
    private _localStorage: LocalStorageService,
    public dialog: MatDialog,
    private modal: NgbModal
  ) { }

  ngOnInit() {
    this.updateEvents();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.providerAvailability) {
      this.updateEvents();
    }
  }

  updateEvents(): void {
    this.events = []; // Clear existing events
    this.providerAvailability.forEach(slotList => {
      let obj;
      if (slotList.type === "member_scheduled") {
        obj = {
          start: new Date(slotList.startDateTime),
          end: new Date(slotList.endDateTime),
          title: slotList.startDateTime + '  -  ' + slotList.endDateTime + ' - ' + slotList.timeZone + ' - ' + slotList.visitType,
          color: colors.yellow
        }
      } else {
        obj = {
          start: new Date(slotList.startDateTime),
          end: new Date(slotList.endDateTime),
          title: slotList.startDateTime + '  -  ' + slotList.endDateTime + ' - ' + slotList.timeZone + ' - ' + slotList.visitType,
          color: slotList.visitType === "In Clinic" ? colors.red : slotList.visitType === "In Home" ? colors.blue : colors.green
        }
      }
      this.events.push(obj);
    });
    this.refresh.next(); // Force calendar to refresh
  }

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
      },
    },
  ];

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
}
